var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Pricing.Audit"),
        width: "900px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view air-markup"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "price-dialog-header" }, [
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: { no: "onOK", type: "primary" },
                on: { click: _vm.onOK }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.CONFIRM")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "onReset" }, on: { click: _vm.onReset } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Reset")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "onCancel" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Back")))]
            )
          ],
          1
        )
      ]),
      _c("air-markup", { ref: "airMarkUp" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }